import { StackWithDividers } from '@components'

import { Divider, useModal } from '@billy/design-system'
import { type ReactElement, useCallback } from 'react'

import { ModalId } from '../../../../../../../../../../enums/modalId'
import { useComponentId, useFormContext } from '../../../../../../../../../../hooks'
import { LegalSettingTypes } from '../../../../../../enums/legalSettingTypes'
import type { ComplianceSettingsFormSchema } from '../../../../../../types/complianceSettingsFormSchema'
import { LegalGuaranteeOfConformityModal } from '../../../../../LegalGuaranteeOfConformityModal'
import { LegalSettingSwitch } from './elements/LegalSettingSwitch'

const legalSettingTypes = Object.values(LegalSettingTypes)

export const LegalSettings = (): ReactElement => {
  const { setValue } = useFormContext<ComplianceSettingsFormSchema>()
  const legalGuaranteeOfConformityModalId = useComponentId(ModalId.LegalGuaranteeOfConformityModal)
  const { open: openLegalGuaranteeOfConformityModal } = useModal(legalGuaranteeOfConformityModalId)

  const handleLearnMoreClick = useCallback(() => {
    openLegalGuaranteeOfConformityModal()
  }, [openLegalGuaranteeOfConformityModal])

  const handleLegalGuaranteeOfConformityEnableChange = useCallback(
    (isEnabled: boolean) => {
      setValue(`legalFormSettings.${LegalSettingTypes.IsLegalGuaranteeOfConformity}`, isEnabled, {
        shouldDirty: true,
      })
    },
    [setValue],
  )

  return (
    <>
      <StackWithDividers divider={<Divider />}>
        {legalSettingTypes.map((legalSettingType) => (
          <LegalSettingSwitch
            key={legalSettingType}
            legalSettingType={legalSettingType}
            onLearnMoreClick={handleLearnMoreClick}
          />
        ))}
      </StackWithDividers>
      <LegalGuaranteeOfConformityModal
        id={legalGuaranteeOfConformityModalId}
        onEnableChange={handleLegalGuaranteeOfConformityEnableChange}
      />
    </>
  )
}
